import { Html5Qrcode } from "html5-qrcode";

/**
 * createQrScanner
 * - start/stopだけ提供する薄いラッパ
 * - Reactに依存しない（UIやstateは持たない）
 */

export function createQrScanner({ readerId, onDecoded, onError } = {}) {
  const html5QrCode = new Html5Qrcode(readerId);

  const config = {
    fps: 15,
    qrbox: { width: 550, height: 550 },
    // videoConstraints: {
    //   width: { ideal: 1920 },
    //   height: { ideal: 1080 },
    // },
  };

  let starting = false;

  async function start() {
    if (starting) return;
    if (html5QrCode.isScanning) return;

    starting = true;
    try {
      await html5QrCode.start(
        { facingMode: "environment" },
        config,
        async (decodedText) => {
          if (onDecoded) await onDecoded(decodedText);
        },
        (err) => {
          // 読めないフレームが多いので、基本は必要な時だけ扱う
          if (onError) onError(err);
        }
      );
    } finally {
      starting = false;
    }
  }

  async function stop() {
    if (starting) return;
    if (!html5QrCode.isScanning) return;

    await html5QrCode.stop();
    await html5QrCode.clear();
  }

  return { start, stop };
}